/* @flow */

import { partialRight } from 'ramda';
import { createSelector } from '@reduxjs/toolkit';
import { assertObject, assertString } from '@braindate/util/lib/assert';
import { hydrateUsers } from '@braindate/domain/lib/user/util';

import { getEntities } from 'src/shared/app/base/util/reduxUtils';

import type { State } from 'src/shared/core/type/reduxTypes';
import type { User } from '@braindate/domain/lib/user/type';

const getValue = (state: State, key: string): any => {
  assertObject(state, 'state');
  assertString(key, 'key');

  return state.app.userAutocomplete[key];
};

export const isUsersAutocompleteFetching: (state: State) => boolean =
  partialRight(getValue, ['isFetching']);

export const getUsersAutocompleteCount: (state: State) => boolean =
  partialRight(getValue, ['count']);

export const getUsersAutocomplete: (state: State) => Array<User> =
  createSelector(
    [partialRight(getValue, ['result']), getEntities],
    (result, entities): any => hydrateUsers(result, entities),
  );
